import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "LEDE ONLY: Basic",
    description:
        "This module is now a story package, so the relateds are actually individual stories. The first (main) story can also display one nested related as a card under the main headline.",
    links: [
        {
            name: "Editorial Team Guide",
            url: "https://docs.google.com/document/d/1XVAaeEBxk8ifuhKiUqNn_jvpwPbTet681IRnLv4MLRQ/edit?tab=t.0#heading=h.bpiv3nmataz0",
        },
        {
            name: "Module Library",
            url: "https://docs.google.com/document/d/1JORaUFwMtPyyoUflTRHKINyllR4zWIJV1bL66Abutis/edit?tab=t.0#heading=h.c00jwar06zck",
        },
        {
            name: "Figma",
            url: "https://www.figma.com/design/gMELOCd5MiIqECTbVITX8y/Homepage?node-id=1949-5300&m=dev",
        },
    ],
};
